function n(t, e = 1) {
  return `v${e.toFixed(1)}/${t}`;
}
export {
  n as default
};
